exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/aco-cuit-dialog/aco-cuit-dialog.component.scss
// module id = ../../../../../src/app/components/cuentas/usuarios/aco-cuit-dialog/aco-cuit-dialog.component.scss
// module chunks = 0